import { render, staticRenderFns } from "./error403.vue?vue&type=template&id=709c6984&scoped=true&"
import script from "./error403.vue?vue&type=script&lang=js&"
export * from "./error403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c6984",
  null
  
)

export default component.exports